

// Import ----------------------------------------------------------------------

// Project
import { VueGlobalInjectable } from "~/libs/Types";
import PageLayout from "~/layouts/Default.vue";
import Utils, { NodeMedia } from "~/libs/Utils";
import MainTitle from "~/components/MainTitle.vue";
import PageContent from "~/components/PageContent.vue";

// Export ----------------------------------------------------------------------

export default VueGlobalInjectable.extend({

    // Component imports -------------------------------------------------------

    components: {
        MainTitle,
        PageLayout,
        PageContent
    },

    // Component Attribute, Properties & Injected ------------------------------

    inject: ["node"],

    // Component Computed Properties -------------------------------------------

    computed: {
        backgroundSrc (): string {
            return Utils.nodeMediaUrl(this.node, NodeMedia.Background);
        },

        hasPageImage (): boolean {
            return !!this.node.page?.layout;
        },

        hasPageBackground (): boolean {
            return !!this.node.page.background;
        },

        hasPageBackgroundTint (): boolean {
            return !!this.node.page.backgroundTint;
        },

        layoutClasses (): object {
            const classes: any = {
                "with-page-background": this.hasPageBackground
            };

            if (this.node.page.backgroundPosition) {
                const positionClass = "background-position-" + this.node.page.backgroundPosition;
                classes[positionClass] = true;
            }

            if (this.node.page.image) {
                classes["with-page-image"] = true;
            }

            return classes;
        },

        layoutStyles (): object {
            if (this.hasPageBackground === false) {
                return {};
            }

            const backgrounds = [];

            if (this.hasPageBackgroundTint) {
                backgrounds.push("linear-gradient(90deg, #373f5e4d 0%, #373f5e4d 100%)");
            }

            backgrounds.push("url(" + this.backgroundSrc + ")");

            return {
                "background-image": backgrounds.join(",")
            };
        }
    }

    // -------------------------------------------------------------------------
});
